import useLanguage from "../../i18n/useLanguage";
import { aiPhotoExamples, aiVideoExamples } from "../../data/ai-examples";
import { AI_ORDER_URL } from "../../data/products";
import AiPhotoExample from "./AiPhotoExample";
import AiVideoExample from "./AiVideoExample";

export default function AiExamples() {
  const { t } = useLanguage();
  return (
    <section id="ai-examples" aria-labelledby="ai-examples-title" className="py-14 border-y border-white/10">
      <p className="text-sm uppercase tracking-[0.2em] text-amber-300 mb-3">{t("Contoh Hasil AI")}</p>
      <h2 id="ai-examples-title" className="text-3xl sm:text-4xl font-bold mb-4">{t("Lihat foto dan video yang bisa dibuat")}</h2>
      <p className="text-gray-400 leading-relaxed max-w-2xl mb-8">{t("Dari konten dengan model hingga visual produk sinematik. Berikut contoh hasil foto dan video dari KlipFlow.")}</p>
      <div className="grid md:grid-cols-2 gap-6 mb-12">
        {aiVideoExamples.map(example => <AiVideoExample key={example.id} example={example} />)}
      </div>
      <h3 className="text-2xl font-bold mb-3">{t("Satu produk, berbagai suasana")}</h3>
      <p className="text-gray-400 leading-relaxed mb-6">{t("Contoh foto produk AI dengan latar dan pencahayaan berbeda. Klik foto untuk melihat ukuran penuh.")}</p>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4">
        {aiPhotoExamples.map(example => <AiPhotoExample key={example.src} example={example} />)}
      </div>
      <a href={AI_ORDER_URL} className="inline-block mt-8 rounded-xl bg-amber-300 px-6 py-3 font-bold text-black hover:bg-amber-400">{t("Pesan Foto / Video AI")}</a>
    </section>
  );
}
